// For Version 1.1, we only have the complete data for 2021-2023.  For earlier years, the data is incomplete. For 2024, we are working on it to release v2.0 soon.
// Source of truth for ITS years
export const ITS_DATA_VALID_YEARS = {
  year_txt: ['2021', '2022', '2023', '2024'],
};

// Display names for ITS attribute fields, used by the filter modal and the
// applied-filter summary in the map sidebar.
export const ITS_FIELD_LABELS = {
  objectid: 'Unique Identifier',
  countyfp: 'FIPS code',
  countyns: 'GNIS code',
  geoid: 'County Identifier',
  namelsad: 'County Name',
  lsad: 'Legal/statistical Code',
  classfp: 'FIPS class code',
  mtfcc: 'MAF/TIGER feature class code',
  csafp: 'Combined statistical area code',
  cbsafp: 'Metropolitan area code',
  metdivfp: 'Metropolitan division code',
  funcstat: 'Functional status',
  aland: 'Land area',
  awater: 'Water area',
  intptlat: 'Latitude',
  intptlon: 'Longitude',
  county: 'County Name',
  fdid: 'Fire Department Identification Number',
  macsid: 'MACS ID',
  firechief: 'Fire Chief',
  notes: 'Extra Notes',
  zip: 'Zip Code',
  address: 'Address',
  city: 'City',
  phone: 'Phone Number',
  calfireunit: 'CALFIRE Unit',
  rrk_region: 'RRK Region',
  primary_ownership_group: 'Primary Ownership Group',
  broad_vegetation_type: 'Broad Vegetation Type',
  region: 'Region',
  wui: 'Wui',
  year_txt: 'Year',
  agency: 'Agency',
  administering_org: 'Administering Org',
  activity_description: 'Activity Description',
  activity_cat: 'Activity Category',
  activity_status: 'Activity Status',
  activity_quantity: 'Activity Quantity',
  entity_type: 'Entity Type',
};
